import { render } from "./Faqs.vue?vue&type=template&id=68aecd62&scoped=true"
import script from "./Faqs.vue?vue&type=script&lang=js"
export * from "./Faqs.vue?vue&type=script&lang=js"

import "./Faqs.vue?vue&type=style&index=0&id=68aecd62&lang=scss"
import "./Faqs.vue?vue&type=style&index=1&id=68aecd62&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3487515193/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68aecd62"]])

export default __exports__